import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.tsx';
import { Provider } from 'react-redux';
import { stores } from './stores/stores.ts';
import { HashRouter } from 'react-router-dom';
import { LoadingProvider } from './context/LoadingContenxt.tsx';
import { AlertProvider } from './hook/useAlert.tsx';
import './i18n';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={stores}>
      <AlertProvider>
        <LoadingProvider>
          <HashRouter>
            <App />
          </HashRouter>
        </LoadingProvider>
      </AlertProvider>
    </Provider>
  </StrictMode>
);
